exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-dialog{height:100%;min-height:100%;overflow:auto}.preview-dialog .el-dialog__header{padding:0;display:none}.preview-dialog .el-dialog__body{height:calc(100% - 0.36458rem);padding:0}.preview-dialog .el-dialog__footer{z-index:9}\n", ""]);

// exports
